module.exports = __webpack_public_path__ + "zvetseni-prsou_27_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_27_after.jpg
// module id = 1319
// module chunks = 0